import React from 'react';
import { SERIF } from './ui';
import { VIBE_EXAMPLES, VIBE_MAX } from '../../../utils/portalPageModel';

const inputBase = {
  border: 'none', borderRadius: 999, background: '#000', boxShadow: 'inset 0 0 0 1px #2A2A2A',
  fontFamily: SERIF, color: '#fff', outline: 'none', minWidth: 0, width: '100%', boxSizing: 'border-box',
};

/**
 * VIBE CHECK — one line in the owner's voice, Times italic in a pill, capped at `VIBE_MAX` (80),
 * with the examples underneath as tap-to-use serif pills. Shared by the Portal Editor and
 * Onboarding v2 so the cap and the examples can only be changed in one place
 * (`utils/portalPageModel`).
 *
 * `examplesLabel` is onboarding's "EXAMPLES THAT WORK · TAP TO USE" eyebrow; the editor's card
 * already carries its own helper line and passes nothing.
 */
export default function VibeField({ value, onChange, height = 56, fontSize = 19, examplesLabel }) {
  return (
    <>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, VIBE_MAX))}
        maxLength={VIBE_MAX}
        placeholder="Better at midnight than at 8pm."
        className="pe-in"
        aria-label="Vibe check"
        data-testid="vibe-input"
        style={{ ...inputBase, height, padding: '0 22px', fontStyle: 'italic', fontSize }}
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {examplesLabel && <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: '.16em', color: '#6B6B6B' }}>{examplesLabel}</span>}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {VIBE_EXAMPLES.map((v) => (
            <button
              key={v}
              type="button"
              onClick={() => onChange(v.slice(0, VIBE_MAX))}
              className="pe-vibe"
              style={{ minHeight: 34, padding: '6px 14px', border: 'none', borderRadius: 999, background: '#1A1A1A', boxShadow: 'inset 0 0 0 1px #2A2A2A', color: '#BDBDBD', fontFamily: SERIF, fontStyle: 'italic', fontSize: 14, textAlign: 'left', cursor: 'pointer', transition: 'background-color .2s, color .2s, box-shadow .2s' }}
            >
              {v}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}

/**
 * MUSIC THAT MOVES ME — three numbered artist pills. `value` is always a 3-length array
 * (`decodePortalPage` pads it); `onChange(i, text)` writes one slot.
 */
export function MusicField({ value, onChange, serif = false }) {
  const placeholders = ['First artist', 'Second', 'Third'];
  return (
    <>
      {[0, 1, 2].map((i) => (
        <label key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, height: 50, padding: '0 8px 0 18px', borderRadius: 999, background: '#000', boxShadow: 'inset 0 0 0 1px #2A2A2A', boxSizing: 'border-box' }} className="pe-in-wrap">
          <span style={{ flexShrink: 0, width: 18, fontSize: 12, fontWeight: 800, color: '#6B6B6B' }}>{serif ? String(i + 1).padStart(2, '0') : i + 1}</span>
          <input
            value={value[i] || ''}
            onChange={(e) => onChange(i, e.target.value)}
            placeholder={placeholders[i]}
            maxLength={80}
            aria-label={`Artist ${i + 1}`}
            data-testid={`artist-${i + 1}`}
            style={{ flex: 1, minWidth: 0, height: '100%', border: 'none', background: 'none', boxShadow: 'none', outline: 'none', fontFamily: serif ? SERIF : 'inherit', fontSize: serif ? 20 : 14, color: '#fff' }}
          />
        </label>
      ))}
    </>
  );
}
